import { render, staticRenderFns } from "./Incentive.vue?vue&type=template&id=6f9b48e9&scoped=true"
import script from "./Incentive.vue?vue&type=script&lang=js"
export * from "./Incentive.vue?vue&type=script&lang=js"
import style0 from "./Incentive.vue?vue&type=style&index=0&id=6f9b48e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9b48e9",
  null
  
)

export default component.exports